import { PORTAL_API_BASE_URL } from '../../../../constants';
import request from '../../../../util/APIUtils';

const BASE = `${PORTAL_API_BASE_URL}/api/admin/lms-resource-catalog`;

const req = (opts) => request({ ...opts, throw400Error: true });

/**
 * Search programs (LEARNING_OBJECT_BUNDLE) by name with coverage counts.
 * @param {string} name - Search term (min 2 chars enforced by API)
 */
export const searchPrograms = async (name) => {
  const qs = new URLSearchParams({ name: String(name).trim() });
  const response = await req({
    url: `${BASE}/programs/search?${qs.toString()}`,
    method: 'GET',
  });
  return Array.isArray(response) ? response : [];
};

/**
 * List courses for a program with optional status filter.
 * @param {number|string} programId
 * @param {{ reviewStatus?: 'PENDING'|'LINKED'|'NOT_ON_CANVAS' }} [params]
 */
export const fetchProgramCourses = async (programId, params = {}) => {
  const qs = new URLSearchParams();
  if (params.reviewStatus) {
    qs.set('reviewStatus', params.reviewStatus);
  }
  const query = qs.toString();
  const response = await req({
    url: `${BASE}/programs/${encodeURIComponent(programId)}/courses${query ? `?${query}` : ''}`,
    method: 'GET',
  });
  return Array.isArray(response) ? response : [];
};
